import DataVScrollBoard from './scroll-board';
export default DataVScrollBoard;
